import { Button, ButtonVariants, VisualizerProject } from "@app/shared";
import { getAllDevices } from "@app/shared/src/api/DeviceControllerClient.gen";
import { saveProject } from "@app/shared/src/api/VisualizerControllerClient.gen";
import { useState } from "react";
import { useFetch, useModel } from "../../../hooks";
import { Input, InputRow, InputWithOptions } from "../../shared";
import { EditProjectFiles } from "./ConfigurationViewer/EditProjectFiles";

type NewProjectWizardProps = {
    onFinished?: (p?: VisualizerProject) => void;
};

export const NewProjectWizard: React.FC<NewProjectWizardProps> = (props) => {
    const [createStep, setCreateStep] = useState<number>(1);
    const [project, projectHelpers] = useModel(VisualizerProject, { videoFps: 20 } as Partial<VisualizerProject>);
    const [devices] = useFetch(getAllDevices);

    const handleNextClick = async () => {
        if (createStep === 1) {
            //Create our project
            if (!project.id) {
                var newProject = await saveProject(project as VisualizerProject);
                console.log("Created new project", newProject);
                if (newProject)
                    projectHelpers.replaceModel(newProject);
            }
        } else if (createStep === 2) {
            await props.onFinished?.(project as VisualizerProject);
        }
        setCreateStep((createStep ?? 0) + 1);
    };
    const handleBackClick = () => {
        console.log("Handle back click", createStep);
        setCreateStep((createStep ?? 0) - 1);
        if (createStep === 1) {
            //If we are going back from the first step, close the wizard
            props.onFinished?.(undefined);
        }
    };

    return (
        <>
            {/* Step 1: Name this project and select the device / facility */}
            {createStep === 1 &&
                <>
                    <InputRow>
                        <Input label="Project Name" {...projectHelpers.bindingsFor("name")}></Input>
                    </InputRow>
                    <InputRow>
                        <InputWithOptions
                            placeholder="device key (ex. DVE8797)"
                            label="Device Key"
                            options={devices?.map(d => ({ label: d.name, value: d.id })) ?? []}
                            {...projectHelpers.bindingsFor("deviceId")}
                        />
                    </InputRow>
                </>
            }

            {/* Upload files (maybe we let them select from media requests?) */}
            {createStep === 2 &&
                <>
                    <EditProjectFiles project={project} setProject={projectHelpers.replaceModel as any} />
                </>
            }

            {/* Wizard buttons */}
            {createStep &&
                <div className="flex flex-row w-9/10 md:w-8/10 lg:w-7/10 m-1 mx-auto place-content-end">
                    <Button onClick={handleBackClick} variant={ButtonVariants.Secondary}>{createStep === 0 ? "Cancel" : "Back"}</Button>
                    <Button onClick={handleNextClick}>Next</Button>
                </div>
            }


        </>
    );
}
